import { useRef } from "react";
import useInlineScript from "../../../hooks/useInlineScript";

export default function Imgur({ id, text }: { id: string; text: string }): JSX.Element {
  const ref = useRef<HTMLDivElement>(null);

  useInlineScript(ref, `<script async src="https://s.imgur.com/min/embed.js"></script>`);

  return (
    <div ref={ref}>
      <blockquote className={"imgur-embed-pub"} data-id={id}>
        <a href={`//imgur.com/${id}`}>{text}</a>
      </blockquote>
    </div>
  );
}
